const initialState = {
  bulkIssuanceResult: null,
}

const SET_BULK_ISSUANCE_RESULT = 'SET_BULK_ISSUANCE_RESULT'
const CLEAR_BULK_ISSUANCE_RESULT = 'CLEAR_BULK_ISSUANCE_RESULT'

export function setBulkIssuanceResult(data) {
  return {
    type: SET_BULK_ISSUANCE_RESULT,
    payload: data,
  }
}

export function clearBulkIssuanceResult() {
  return {
    type: CLEAR_BULK_ISSUANCE_RESULT,
  }
}

export default function bulkIssuanceResultReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case SET_BULK_ISSUANCE_RESULT:
      return { ...state, bulkIssuanceResult: action.payload }

    case CLEAR_BULK_ISSUANCE_RESULT:
      return { ...state, bulkIssuanceResult: null }

    default:
      return state
  }
}
